import { getPdfSizes } from "helpers";
import { t } from "i18next";
import jsPDF from "jspdf";
import moment from "moment";

import { ReturnDetails } from "../../returns.types";

interface renderTitlesProps {
  pdf: jsPDF;
  bigFontSize: number;
  normalFontSize: number;
  returnDetails: ReturnDetails;
}

export const renderTitles = ({
  pdf,
  bigFontSize,
  normalFontSize,
  returnDetails
}: renderTitlesProps) => {
  const { pageWidth } = getPdfSizes(pdf);

  pdf
    .setFontSize(bigFontSize)
    .setFont("helvetica", "normal", "bold")
    .text(`${t("Return")} #${returnDetails.id}`, pageWidth / 2, 36, {
      align: "center"
    });

  pdf.setFontSize(normalFontSize);
  pdf.text(
    `${t("Return requested at")}: ${moment(
      returnDetails.returnRequestedAt
    ).format("DD MMMM, YYYY")}`,
    pageWidth / 2,
    51,
    { align: "center" }
  );

  const refundTotal = returnDetails?.refundTotal ?? 0;

  pdf.text(
    `${t("Refund Total")}: ${refundTotal?.toLocaleString("en-US")} FCFA`,
    pageWidth / 2,
    64,
    { align: "center" }
  );
};
